import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';

import types from '../../common/model-api/types';

import {Link} from 'react-router';
import {ButtonGroup} from 'react-bootstrap';
import PagingGrid, {defaultPageSize, processPagingParams} from '../fw/PagingGrid.react';
import AddButton from '../fw/AddButton.react';
import urlMapping from '../app/URLMapping';
import {FormattedMessage, injectIntl, defineMessages} from 'react-intl';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import DeleteButton from '../fw/DeleteButton.react';
import * as BrowserPermission from "../BrowserPermission";
import {getProfile} from '../app/auth';
import {ASCENDING} from '../fw/Grid.react';
import {OrganisationRole, ROLE_OWNER, ROLE_USER} from '../../common/model-api/Organisation2UserType';
import SaveRoleMutation from './SaveRoleMutation.react';
import LoadingButtonNew from '../fw/LoadingButtonNew.react';
import EventTracker from '../app/EventTracker';
import ResendInvitationMutation from '../invitations/ResendInvitationMutation';
import mutationError from '../channel-defs/mutationError';
import {ErrorModal} from '../app/errorDisplayer';
import * as Permission from '../../common/util/Permission';

import '../users/User.scss';

const messages = defineMessages({
    title: {id: 'userList.title', 'defaultMessage': 'Users'},
	invitation: {id: 'userList.inviteUser', defaultMessage: 'Inviate user'},
	cancel: {id: 'common.cancel', defaultMessage: 'Cancel'},
	save: {id: 'common.save', defaultMessage: 'Save'},
});

const invitationDelete = defineMessages({
	title: {id: 'userList.invitaionRevoke.title', defaultMessage: 'Revoke Invitation'},
	message: {id: 'userList.invitaionRevoke.message', defaultMessage: 'The invitation to {email} will be deleted and the sent invitation will be invalid.'},
	button: {id: 'userList.invitaionRevoke.button', defaultMessage: 'Revoke'},
});

const userDelete = defineMessages({
	title: {id: 'userList.userRemove.title', defaultMessage: 'User Remove'},
	message: {id: 'userList.userRemove.message', defaultMessage: 'Do you want to remove {user}? User will no longer be able to view any of your integrations.'},
	button: {id: 'userList.userRemove.button', defaultMessage: 'Remove'},
});

class Organisation2UserList extends React.Component {

    typeName = 'organisation2user';

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object,
        user: PropTypes.object.isRequired
    };

	constructor(props) {
		super(props);

		this.state = {
			loggerUserEmail: null,
			editUserRole: {},
			data: this.getMergedData(props)
		};
	}

	getMergedData(props) {
		let data = props.user.organisation.organisations2user;

		if (props.user.organisation.invitations && this.props.user.organisation.invitations.edges) {
			data.edges = data.edges.concat(this.props.user.organisation.invitations.edges.map(item => {
				item.node.invitation = true;
				item.node.user = {
					id: item.node.id,
					realId: item.node.realId,
					email: item.node.email
				};
				return item;
			}));
		}

		data.edges = data.edges.filter((a) => a && a.node && a.node.user);

		data.edges.sort((itemA, itemB) => {
			return itemA.node.user.email.localeCompare(itemB.node.user.email);
		});

		return data;
	}

    componentWillMount() {
        getProfile().then((profile) => {
            this.setState({'loggerUserEmail': profile.email});
        }).catch(() => {});
    }

	startEditRole(row) {
		let editUsers = this.state.editUserRole;

		editUsers[row.user.email] = row.role || ROLE_OWNER; // fallback as default value for old user without set role

		this.setState({
			editUserRole: editUsers
		});
	}

	saveEditRole(row) {
		if (this.state.editUserRole[row.user.email] !== row.role) {
			let newRole = this.state.editUserRole[row.user.email];

			this.props.relay.commitUpdate(
				new SaveRoleMutation({
					role: newRole,
					id: row.realId,
				}), {onSuccess: () => {this.cancelEditRole(row);}, onFailure:  () => {this.cancelEditRole(row);}}
			);

			let data = this.state.data;
			let index = data.edges.findIndex(({node}) => node.user.email === row.user.email);
			data.edges[index].node.role = newRole;

			this.setState({
				data: data
			});
		}
		else {
			this.cancelEditRole(row);
		}
	}

	cancelEditRole(row) {
		let editUsers = this.state.editUserRole;

		editUsers[row.user.email] = false;

		this.setState({
			editUserRole: editUsers
		});
	}

	changeEditRole(row, newRole) {
		let editUsers = this.state.editUserRole;

		editUsers[row.user.email] = newRole;

		this.setState({
			editUserRole: editUsers
		});
	}

	onClickResend(row) {
		return new Promise((resolve, reject) => {
			EventTracker.trackEvent(EventTracker.EVENT_CLICKS, {
				event: 'invitations-resend',
				type: 'application'
			});

			let onFailure = (transaction) => {
				let error = mutationError(transaction);
				ErrorModal.show(error.toString());

				reject();
			};

			let onSuccess = () => {
				resolve();
			};

			Relay.Store.commitUpdate(new ResendInvitationMutation({invitation: {...row}}), {
				onFailure,
				onSuccess
			});
		});
	}

    render() {
        let type = types[this.typeName];

        let canEditInvitations = types['invitations'].canCreate(BrowserPermission.getPermissionObject(), this.props.user.organisation, this.props.user.organisation.realId) && types['invitations'].canUserUpdate();
		let {loggerUserEmail} = this.state;
		let onlyUser = this.state.data.edges.length === 1;

        return (
            <AppPanel breadcrumbParams={[
				{type: type, text: this.props.intl.formatMessage(messages.title)},
                {type: types['organisations'], data: this.props.user.organisation}
			]}
			className="Organisation2Users"
			title={this.props.intl.formatMessage(messages.title)}>
                <div>
					<div style={{position: 'relative'}}>
						<PagingGrid
							columns={{
								'user.name': {
									width: 25,
									withoutMapping: true,
									header: (<FormattedMessage defaultMessage="User" id="org2user.user" />),
									link: false,
									showAlways: true,
									className: (item) => {
										return item.invitation === true ? 'invitation' : null;
									},
									render: (column, item) => {
										let {user} = item;
										let name = ((user.firstname || '') + ' ' + (user.surname || '')).trim();

										if (!name) {
											name = '-';
										}

										return (
											<div>
												<img className="userPicture" src={user.picture} />&nbsp;&nbsp;<span className="name">{name}</span>
												{loggerUserEmail === item.user.email
													? (<span className="you" key="you"> <FormattedMessage defaultMessage="(you)" id="org2user.you" /></span>)
													: null
												}
											</div>
										);
									}
								},
								'user.email': {
									width: 25,
									link: false,
									showAlways: true,
									sorting: ASCENDING,
									className: (item) => {
										return item.invitation === true ? 'invitation' : null;
									}
								},
								'role': {
									width: 25,
									link: false,
									showAlways: true,
									className: (item) => {
										return item.invitation === true ? 'invitation' : null;
									},
									// eslint-disable-next-line max-params
									render: (column, item, url, columnMapping) => {
										let role = item[column] || 'admin';

										if (item.invitation) {
											return (<span>{this.props.intl.formatMessage({defaultMessage: OrganisationRole[item['role'] ? item['role'] : ROLE_USER].name, id: "metadata.invitations.role.values." + (item['role'] ? item['role'] : ROLE_USER) + ".name"})} &ndash; <FormattedMessage defaultMessage="Invitation" id="userList.invitation" /></span>);
										}

										if (this.state.editUserRole[item.user.email]) {
											return (
												<div>
													<select className="textValue form-control" onChange={(event) => { this.changeEditRole(item, event.target.value); }} value={this.state.editUserRole[item.user.email] || role}>
														{Object.keys(OrganisationRole).map(value => {
															return (<option key={value} value={value}>
																{this.props.intl.formatMessage({defaultMessage: OrganisationRole[value].name, id: "metadata.invitations.role.values." + value + ".name"})}</option>);
														})}
													</select>
													&nbsp;
													<ButtonGroup>
														<LoadingButtonNew className="btn btn-primary" icon="fa-check" onClick={() => { this.saveEditRole(item); }} progressText={(<FormattedMessage defaultMessage="Saving…" id="common.saving" />)} text={<FormattedMessage defaultMessage="Save" id="common.save" />} title={this.props.intl.formatMessage(messages.save)}></LoadingButtonNew>
														<Link className="btn btn-default" onClick={() => { this.cancelEditRole(item); }} title={this.props.intl.formatMessage(messages.cancel)}><span><span className="fa fa-times"></span>&nbsp;<FormattedMessage defaultMessage="Cancel" id="common.cancel" /></span></Link>
													</ButtonGroup>
												</div>
											);
										}

										return (
											<div>
												<span className="textValue">{this.props.intl.formatMessage({defaultMessage: OrganisationRole[role].name, id: "metadata.invitations.role.values." + role + ".name"})}</span>
												{loggerUserEmail !== item.user.email && type.canUpdate(BrowserPermission.getPermissionObject(), item, item.organisation_id) && type.canUserUpdate(item)
													? <Link className="btn btn-default" onClick={() => { this.startEditRole(item); }}><span className="fa fa-pencil"></span>&nbsp;<FormattedMessage defaultMessage="Change" id="common.change" /></Link>
													: null
												}
											</div>
										);
									}
								},
								'': BrowserPermission.hasOrganisationPermission(Permission.PERM_EDIT_INVITATION, this.props.user.organisation.realId) ? {
									width: 25,
									withoutMapping: true,
									link: false,
									showAlways: true,
									align: 'right',
									className: 'alignRight',
									// eslint-disable-next-line max-params
									render: (column, item) => {
										if (item.invitation) {
											return (
												<div>
													<ButtonGroup>
														{ BrowserPermission.hasOrganisationPermission(Permission.PERM_EDIT_INVITATION, this.props.user.organisation.realId)
															? <LoadingButtonNew
																className="btn btn-default"
																doneText={(<FormattedMessage defaultMessage="Send" id="org2user.send" />)}
																icon="fa-envelope-o"
																onClick={() => this.onClickResend(item)}
																progressText={(<FormattedMessage defaultMessage="Sending" id="org2user.sending" />)}
																text={(<FormattedMessage defaultMessage="Resend" id="org2user.resend" />)}
															/>
															: null
														}
														<DeleteButton
															confirmDialogConfig={{
																title: this.props.intl.formatMessage(invitationDelete.title),
																message: this.props.intl.formatMessage(invitationDelete.message, {email: item.email}),
																button: this.props.intl.formatMessage(invitationDelete.button),
															}}
															data={item}
															deleteFatQuery={Relay.QL `fragment on DeleteInvitationPayload {
																updatedNode {
																	id
																}
															}`}
															deleteMutation={Relay.QL `mutation { deleteInvitation }`}
															key={'deleteButton' + item.email}
															metadata={type}
															onSuccess={() => {
																let data = this.state.data;

																data.edges = data.edges.filter(row => row.node.user.email !== item.user.email);
																this.setState({
																	data: data
																});
															}}
															organisationId={item.organisation_id}
															title={<FormattedMessage defaultMessage="Remove" id="common.remove" />}
															types={types}
															urlMapping={urlMapping}
														/>
													</ButtonGroup>
												</div>
											);
										}

										let name = ((item.user.firstname || '') + ' ' + (item.user.surname || '')).trim();

										if (!name || name === '' || name === ' ') {
											name = item.user.email;
										}

										return (
											<div>
												{onlyUser ? null : (
														<DeleteButton
															confirmDialogConfig={{
																title: this.props.intl.formatMessage(userDelete.title),
																message: this.props.intl.formatMessage(userDelete.message, {user: name}),
																button: this.props.intl.formatMessage(userDelete.button),
															}}
															data={item}
															deleteFatQuery={Relay.QL `fragment on DeleteOrganisation2UserPayload {
																updatedNode {
																	id
																}
															}`}
															deleteMutation={Relay.QL `mutation { deleteOrganisation2User }`}
															key={'deleteButton' + item.user.email}
															metadata={type}
															onSuccess={() => {
																let data = this.state.data;

																data.edges = data.edges.filter(row => row.node.user.email !== item.user.email);
																this.setState({
																	data: data
																});
															}}
															organisationId={item.organisation_id}
															style={{visibility: loggerUserEmail === item.user.email && !BrowserPermission.getDeveloperMode() ? 'hidden' : 'visible'}}
															title={<FormattedMessage defaultMessage="Remove" id="common.remove" />}
															types={types}
															urlMapping={urlMapping}
														/>
													)
												}
											</div>
										);
									}
								} : undefined
							}}
							edges={this.state.data}
							filterUndefinedColumns={false}
							firstLevelTypes
							metadata={type}
							pageInfo={this.state.data.pageInfo}
							parent={this.props.user.organisation}
							relay={this.props.relay}
							urlMapping={urlMapping} />

						{canEditInvitations ?
							<AddButton icon="fa-fw fa-user-plus" metadata={types['invitations']} organisationId={this.props.user.organisation.realId} parent={this.props.user.organisation} title={this.props.intl.formatMessage(messages.invitation)} urlMapping={urlMapping} />
						: null}
					</div>

					{onlyUser
						? (<div className="content emptyScreen">
							<img src="/cdn/emptyScreenUsers.svg" width="300" />
							<h2><FormattedMessage defaultMessage="Users and Invitations" id="users.empty.title" /></h2>
							<span className="description"><FormattedMessage
								defaultMessage="Share your channel and screen settings accross multiple users in your team."
								id="Users.empty.description"/></span>
						</div>)
						: null
					}
                </div>
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(Organisation2UserList), (props) => {
    return props.user.organisation;
}), {
    initialVariables: {
        organisationId: null,
        first: 2000, // TODO pagination for the merge list
        after: null,
    },
    prepareVariables (variables) {
        processPagingParams(variables);

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    name,
                    realId,
                    organisations2user(first: $first, after: $after) {
                        edges {
                            node {
                                id,
                                realId,
                                organisation_id,
                                role,
                                user {
                                    id,
                                    firstname,
                                    surname,
                                    email,
									picture
                                }
                            }
                        },
                        pageInfo {
                            hasNextPage,
                            hasPreviousPage,
                            startCursor,
                            endCursor
                        }
                    }
					invitations(first: $first, after: $after) {
                        edges {
                            node {
                                id,
                                realId,
                                email,
                                role,
                                createdAt,
								organisation_id,
                            }
                        },
                        pageInfo {
                            hasNextPage,
                            hasPreviousPage,
                            startCursor,
                            endCursor
                        }
                    }
                }
            }
        `,
    },
});
